import { Box, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CardWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  minWidth: 330,
}));

export const DocName = styled(Typography)(() => ({
  fontWeight: 500,
  color: '#595959',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const FileCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '20px',
  borderRadius: '12px',
  border: '1px solid #D0D5DD',
  width: '100%',
  height: 112,
  span: {
    color: theme.palette.primary.main,
  },
}));

export const FileInfo = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  overflow: 'hidden',
  flex: 1,
}));

export const FileName = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 500,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: theme.palette.primary.main,
}));

export const FileSize = styled(Typography)(() => ({
  fontSize: '12px',
  color: '#595959',
}));

export const DeleteIconButton = styled(IconButton)(() => ({
  span: {
    color: '#E7000B',
  },
}));
